import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import LoadingScreen from "@/components/LoadingScreen";
import LandingPage from "@/pages/LandingPage";
import InsightsPage from "@/pages/InsightsPage";
import ArticlePage from "@/pages/ArticlePage";
import AdminPage from "@/pages/AdminPage";

function App() {
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState(
    () => localStorage.getItem("teamx-theme") || "dark"
  );

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    root.classList.toggle("light", theme === "light");
    localStorage.setItem("teamx-theme", theme);
  }, [theme]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2300);
    return () => clearTimeout(t);
  }, []);

  const toggleTheme = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    []
  );

  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AnimatePresence>
            {loading && <LoadingScreen key="loader" />}
          </AnimatePresence>
          <Routes>
            <Route
              path="/"
              element={
                <LandingPage
                  started={!loading}
                  theme={theme}
                  onToggleTheme={toggleTheme}
                />
              }
            />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:slug" element={<ArticlePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
